import React, { useEffect, useState } from "react";
import api from "../api";
import Header from "../components/Header";
import Hero from "../components/Hero";
import LogoMarquee from "../components/LogoMarquee";
import VoucherStores from "../components/VoucherStores";
import VideoMessages from "../components/VideoMessages";
import AdminTools from "../components/AdminTools";
import Fulfilment from "../components/Fulfilment";
import Support from "../components/Support";
import Integrations from "../components/Integrations";
import CaseStudies from "../components/CaseStudies";
import GrowCTA from "../components/GrowCTA";
import Pricing from "../components/Pricing";
import Blog from "../components/Blog";
import Footer from "../components/Footer";
import CookieBanner from "../components/CookieBanner";

export default function Landing() {
  const [content, setContent] = useState({});
  const [articles, setArticles] = useState([]);
  const [businesses, setBusinesses] = useState([]);

  useEffect(() => {
    api.get("/site-content").then(({ data }) => setContent(data)).catch(() => {});
    api.get("/articles").then(({ data }) => setArticles(data)).catch(() => {});
    api.get("/businesses/public").then(({ data }) => setBusinesses(data)).catch(() => {});
  }, []);

  const sections = content.sections || {};
  const show = (k) => sections[k] !== false;
  const blocks = {
    logos: <LogoMarquee businesses={businesses} />,
    stores: <section id="features"><VoucherStores content={content} /></section>,
    video: <VideoMessages content={content} />,
    admin: <AdminTools content={content} />,
    fulfil: <Fulfilment content={content} />,
    support: <Support content={content} />,
    integrations: <Integrations content={content} />,
    case_studies: <section id="clients"><CaseStudies content={content} /></section>,
    pricing: <Pricing />,
    grow: <section id="pricing"><GrowCTA content={content} /></section>,
    blog: <Blog content={content} articles={articles} />,
  };
  const saved = (content.section_order || []).filter((k) => blocks[k]);
  const order = [...saved, ...Object.keys(blocks).filter((k) => !saved.includes(k))];

  return (
    <>
      <Header content={content} />
      <Hero content={content} />
      {order.filter(show).map((k) => <React.Fragment key={k}>{blocks[k]}</React.Fragment>)}
      <Footer content={content} />
      <CookieBanner />
    </>
  );
}
